import { PropsWithChildren } from "react";
import { Row, Col } from "reactstrap";

interface Props {
    title?: string;
}

const Breadcrumb = ({ title = '', children = null }: PropsWithChildren<Props>) => {
  return (
    <Row>
      <Col xs={12} className="page-title-box d-sm-flex align-items-center justify-content-start">
          <h4 className="mb-sm-0 font-size-18">{title}</h4>
          {children}
      </Col>
    </Row>
  );
};

export default Breadcrumb;
